import { combineReducers } from 'redux';

import success from './success';
import loading from './loading';
import errors from './error';
import apiDocs from './api-docs';
import organisation from './organisation';
import authUser from './auth-user';
import site from './site';
import invitation from './invitation';
import membership from './membership';
import openBankingDiretory from './service-directory';
import countryInformation from './country-information';
import html from './html';
import ui from './ui';
import contentDoc from './content-doc';
import featureItems from './feature-item';

const rootReducer = combineReducers({
  loading,
  errors,
  success,
  site,
  apiDocs,
  authUser,
  organisation,
  invitation,
  membership,
  
  
  openBankingDiretory,
  countryInformation,
  html,
  ui,
  contentDoc,
  featureItems,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
